import { Container } from '@mui/material';
import Logo from 'common/components/Logo';

const Mantenimiento = () => {
    return (
        <>

            <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
                <Logo logoType="Large" />
                <h2>Esta página se encuentra en mantenimiento :(</h2>
                <h3>Pedimos disculpas por las molestias ocasionadas</h3>
            </Container>

        </>
    )
}

export default Mantenimiento